import React from "react";
/*
import {
  hf,
  _hmDTM,
  ht,
  cr,
  f,
  gs,
  cmFTH,
  cmLSG,
  useNgnz,
  //  useSrpz,
  _cv_31___Mz,
  _cv_51___Mz,
  _cv_60___Mz,
  _cv_61___Mz,
} from "lib";
*/
import * as _cm from "./_cm";
import * as _cmFTH from "./_cmFTH"; // 廃止予定
import * as cmLSG from "./_cmLSG";
import * as cr from './_cr';
import * as gs from "./_csGbl";
import { useNgnz } from "./_csNgn";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_51___Mz from "./_cv_51___Mz";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as _cv_61___Mz from "./_cv_61___Mz";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as icm from "./icm";
import * as icv from "./icv";
import * as ihd from "./ihd";
import * as ihm from "./ihm";
import * as ihv from "./ihv";

import * as e from "./e.json";

import * as _hd_60 from './_hd_60';
import * as ihdI10 from './ihdI10';
import * as ihdI17 from './ihdI17';
import * as ihdI15 from './ihdI15';

import * as icvI10___Mz from "./icvI10___Mz";
import * as icvI15___Mz from "./icvI15___Mz";
import * as icvI18___Mz from "./icvI18___Mz";
import * as icvI19___Mz from "./icvI19___Mz";
import * as icvI1z___Mz from "./icvI1z___Mz";

export const chkEtyI1z1 = (pz: {
  // check i1z1 epmty
  i1z1s: _ht.ls;
  cntMax: _ht.n;
}) => {
  let _b = true;
  //  _hm.getRng(icv.nI1z1CntMax-1, 0).map( ( _nIdx: _ht.n ) => {
  _hm.getRng(pz.cntMax - 1, 0).map((_nIdx: _ht.n) => {
    if (_b && pz.i1z1s[_nIdx]?.i1z1i10r1f && pz.i1z1s[_nIdx]?.i1z1i10r1f != -1)
      _b = false;
  });
  return _b;
};

export const chkPmn = (icn: _ht.s) => {
  // check permission
  const _gUserz = gs.useUserz();
  //hf.l(`icm 48: ${hf.s(_gUserz.crt._40rz)}`)
  let _b = false;
  switch (icn) {
    case "dld":
      if (
        _gUserz.crt._40rz?.["11021"] ||
        _gUserz.crt._40rz?.["11022"] ||
        _gUserz.crt._40rz?.["11023"] ||
        _gUserz.crt._40rz?.["11024"] ||
        _gUserz.crt._40rz?.["12121"] ||
        _gUserz.crt._40rz?.["2z121"]
      )
        _b = true;
      break;
    case "stg":
      if (
        _gUserz.crt._40rz?.["2z311"] ||
        _gUserz.crt._40rz?.["2z411"] ||
        _gUserz.crt._40rz?.["2z511"] ||
        _gUserz.crt._40rz?.["2z611"] ||
        _gUserz.crt._40rz?.["2z711"] ||
        _gUserz.crt._40rz?.["2z811"] ||
        _gUserz.crt._40rz?.["2z911"] ||
        _gUserz.crt._40rz?.["2za11"] ||
        _gUserz.crt._40rz?.["2zb11"]
      )
        _b = true;
      break;
    /*
    case '19111':
      if (
        _gUserz.crt._40rz?.['19111']
      ) _b = true;
      break;
*/
    default:
      if (_gUserz.crt._40rz?.[icn]) _b = true;
      break;
  }
  //_b = true;
  //hf.l(`icm 432: ${hf.s(_gUserz.crt._10rz)}`)
  if (
    _gUserz.crt._10rz?._10r_31r1f == 0 &&
    _gUserz.crt._10rz?._icn == icv.icnAmn
  )
    _b = true;
  return _b;
};

export const grtBkd = (pz: {
  // get booked
  i1zs: _ht.dz;
  bMplDay?: _ht.b;
}) => {
  const _rz = {} as _ht.dz;
  pz.i1zs?.map((_i1zz: _ht.dz) => {
    //    const _date = _i1zz?.i1zrz.i1zrd3100s;
    //    _i1zz?.i1z1s.filter(( _i1z1z: _ht.dz ) => _i1z1z._dlt != 1 ).map( ( _i1z1z: _ht.dz ) => {
    //hf.l(`icm 101: ${hf.s(_i1zz)}`);
    ihd.nd(_i1zz?.i1z1s).map((_i1z1z: _ht.dz) => {
      const _date = pz.bMplDay ? _i1z1z.i1z1d1100s : _i1zz.i1zrz.i1zrd3100s;
      //      const _date = _i1zz.i1zrz.i1zrd3100s;
      const _roomFst = _i1z1z.i1z1i10r1f;
      const _zoneFst = _i1z1z.i1z1i1111f;
      if (!_rz[_roomFst]) _rz[_roomFst] = {};
      if (!_rz[_roomFst][_zoneFst]) _rz[_roomFst][_zoneFst] = {};
      if (!_rz[_roomFst][_zoneFst][_date]) _rz[_roomFst][_zoneFst][_date] = {};
      _rz[_roomFst][_zoneFst][_date].bBkd = true;
    });
  });
  //hf.l(`icm 131: ${hf.s(_rz)}`);
  return _rz;
};

export const grtI18rab100s = (icn1: _ht.s, icn2: _ht.s) => {
  return `${icn1 ?? ""}-${_hm.pdg(icn2 ?? "", 5, "0")}`;
};

/*
export const getDayCtg = (pz: {
  // 日祝・土曜・平日の取得
  date: _ht.s,
  _601s: _ht.ls,
}) => {
  const _dow = _hmDTM.cvtDow(pz.date);
  //hf.l(`icm 130: ${pz.date}, ${_dow}`);
  if (_dow == "日" || _hm.i(pz.date, pz._601s)) return "日祝";
  if (_dow == "土") return "土曜";
  return "平日";
};
*/

/**
@function
@description 利用料 i1z1m1100i を更新する
@param i1zz 更新対象
*/
export const udtFeeAsync = async (pz: {
  i1zz: _ht.dz,
}) => {

  const _dz = {
    i10rs: [] as _ht.ls,
    _601s: [] as _ht.ls,
    i15rz: {} as _ht.dz,
  };

  await _hm.ectPrlAsync([
    async () => {
      const _i18z = await icvI18___Mz.loadI18rDzAsync({
        i18r_fst: pz.i1zz.i1zrz.i1zri18r1f,
      });
      _dz.i15rz = _i18z?.i15rz;
    },
    async () => {
      _dz.i10rs = await icvI10___Mz.loadI10rLsAsync({ // 団体種別上予約できない部屋も料金計算可能
        _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
        lwrType: 1,  
      });
    },
    async () => {
      const _date = pz.i1zz.i1zrz.i1zrd3100s ?? _hmDTM.getTdy();
      _dz._601s = await _cv_60___Mz.load_601AsAsync({ // 祝日
        dates: _hmDTM.grtDates(_hmDTM.cvtFdm(_date), _hmDTM.cvtLdm(_date)),
      });
    },
  ])

  ihm.udtFee({
    i1zz: pz.i1zz,
    i10rs: _dz.i10rs,
    _601s: _dz._601s,
    i15rz: _dz.i15rz,
  })
  return pz.i1zz;
};

export const getI111s = (pz: { i10r_fst: _ht.n; i10rs: _ht.ls }) => {
  const _i10rz = _hm.getDz(pz.i10rs, pz.i10r_fst, "_fst");
  const _i11rz = _hm.get1(_i10rz?.cldz?.i11rs, {});
  const _i111s = _i11rz?.cldz?.i111s ?? [];
  return _i111s;
};

export const getI1z1Atv = (i1z1s: _ht.ls) => {
  // get active i1z1z
  const _ls = _hm.f(i1z1s) ? 
      ihd.nd(i1z1s).filter((_i1z1z: _ht.dz) => _i1z1z._dlt != 1 && (_i1z1z.i1z1i1111f > 0 || _i1z1z.i1z1i1111f == -999))// その他１時間を考慮
    : [];
  return _ls
};

//export const getI1z1EtyIdx = (pz: {
export const getI1z1EtyIdx = (pz: {
  // get empty i1z1 index
  i1zz: _ht.dz;
  cntMax: _ht.n;
}) => {
  let _etyIdx = -1;
  //  _hm.getRng(icv.nI1z1CntMax-1, 0).map( ( _idx: _ht.n ) => {
  _hm.getRng(pz.cntMax - 1, 0).map((_idx: _ht.n) => {
    if (
      _etyIdx == -1 &&
      (!pz.i1zz.i1z1s[_idx] ||
        !pz.i1zz.i1z1s[_idx]?.i1z1i10r1f ||
        pz.i1zz.i1z1s[_idx]?.i1z1i10r1f == -1)
    )
      _etyIdx = _idx;
  });
  return _etyIdx;
};

export const grtCdrDtmzAsync = async (pz: { ctt: _ht.s; _31r_fst: _ht.n }) => {
  const _gStgz = gs.useStgz();
  const _dateStt =
    pz.ctt == "r"
      ? _gStgz.crt.rsvSttDate
      : pz.ctt == "e"
      ? _gStgz.crt.alyMthSttDate
      : "";
  const _dateEnd =
    pz.ctt == "r"
      ? _gStgz.crt.rsvEndDate
      : pz.ctt == "e"
      ? _gStgz.crt.alyMthEndDate
      : "";
  let _dateCrt = _hmDTM.getTdy();
  if (_dateCrt < _dateStt) _dateCrt = _dateStt;

  const _hdys = await _cv_60___Mz.load_601AsAsync({
    dateStt: _dateStt,
    dateEnd: _dateEnd,
  });
  const _dmds = await _cv_61___Mz.load_611AsAsync({
    dateStt: _dateStt,
    dateEnd: _dateEnd,
    cdn: `_611_31r1f=${pz._31r_fst}`,
  });

  const _dz = {
    crt: _dateCrt,
    stt: _dateStt,
    end: _dateEnd,
    hdys: _hdys,
    dmds: _dmds,
  };
  return _dz;
};

export const grtI1z1z = (pz: {
  i1z1d1100s: _ht.s; // date
  i10r_fst: _ht.n;
  i10rs: _ht.ls;
  i111_fst?: _ht.n;
  i15ra6100i?: _ht.n; // １種・２種の特定に必要
  _601s: _ht.ls, // 祝日：利用料の算出に必要
}) => {
  const _i1z1z = {} as _ht.dz; // ここで _dlt を設定すると全要素に反映されることに注意

  if (pz.i10r_fst) {
    _i1z1z.i1z1i10r1f = pz.i10r_fst;
    _i1z1z._dlt = -1;
    const _i10rz = _hm.getDz(pz.i10rs, pz.i10r_fst, "_fst");
    const _i11rz = _hm.get1(_i10rz?.cldz.i11rs, {});
    const _i111s = _i11rz?.cldz.i111s;
    if (pz.i111_fst) {
      _i1z1z.i1z1i1111f = pz.i111_fst;
      const _i111z: _ht.dz | undefined =
        pz.i111_fst == ihv.otrz._fst ? // 時間帯が指定されている場合
          ihv.otrz
        : _hm.getDz(_i111s, pz.i111_fst, "_fst");
/*
      const _i101z = 
        pz.i111_fst == ihv.otrz._fst ? // その他１時間
          {} 
        : _i111z?.cldz.i101s[0];
*/
/*
      let _i101z = {}
      if (_i1z1z.i1z1i1111f != ihv.otrz._fst) { // その他１時間以外
        _i111z?.cldz.i101s.map((_i101z2: _ht.dz) => {
          if (
            _i1z1z.i1z1d1100s >= _i101z2.i101d1110s &&
            _i1z1z.i1z1d1100s <= _i101z2.i101d1120s
          ) { // 適用開始日以降適用開始日以前の場合
            _i101z = _i101z2
          }
        })
      }
*/
      const _i101z = ihm.getI101z({
        i1z1d1100s: pz.i1z1d1100s,
        i1z1i1111f: pz.i111_fst,
        i101s: _i111z?.cldz?.i101s
      })
      // _hm.l(`icm 305: ${_hm.s(_i111z?.cldz.i101s)}`);
      const _dz = getTime({
        // 開始・終了時刻
        i1zrd3100s: pz.i1z1d1100s,
        i111_fst: pz.i111_fst,
        i111z: _i111z ?? {},
        i11ra1100i: _i11rz?.i11ra1100i,
        i11ra1200i: _i11rz?.i11ra1200i,
        i15ra6100i: pz.i15ra6100i,
        _601s: pz._601s,
      });
      _i1z1z.i1z1d1100s = pz.i1z1d1100s;
      _i1z1z.i1z1a1100i = _dz.stt;
      _i1z1z.i1z1a1200i = _dz.end;
      _i1z1z.i1z1a2100s = _i10rz?._pfx ?? "";
      _i1z1z.i1z1a2200s = _i111z?._pfx ?? "";
      _i1z1z.i1z1m1100i = ihm.getFee({
        // 利用料
        i1zrd3100s: pz.i1z1d1100s,
        i10ra2100i: _i10rz?.i10ra2100i,
        i111_fst: pz.i111_fst,
        i11ra1100i: _i11rz?.i11ra1100i,
        i11ra1200i: _i11rz?.i11ra1200i,
        i101z: _i101z,
        i15ra6100i: pz.i15ra6100i,
        _601s: pz._601s,
      });
    }
  }

  return _i1z1z;
};

export const grtI1z2z = (pz: {
  // generate i1z2z
  i17r_fst: _ht.n;
  i17rs: _ht.ls;
}) => {
  const _i17rz = _hm.getDz(pz.i17rs, pz.i17r_fst, "_fst");

  const _i1z2z = {
    i1z2i17r1f: pz.i17r_fst,
    i1z2a2100s: _i17rz?._pfx, // 予約内容の表示に必要
    _dlt: -1,
  };

  return _i1z2z;
};

export const grtRoomIdz = (i10rs: _ht.ls) => { // 外部連携する roomID, childRoomID を生成 icm, ism 各々で同一内容を定義していることに留意（ライブラリ配置が異なるため各々で定義）
  let _roomIds = (i10rs ?? [])
  _roomIds = _roomIds.filter((_i10rz: _ht.dz) => _i10rz.i10rt1100i == 10 && _hm.f(_i10rz.i10ra3100s)) // 単体部屋で部屋IDが設定されているもののみ
  _roomIds = _roomIds.map((_i10rz: _ht.dz) => _i10rz.i10ra3100s);
  _roomIds = Array.from(new Set(_roomIds)); // 重複削除
  _roomIds = _roomIds.sort((_id1: _ht.s, _id2: _ht.s) => { // 部屋IDが若い順
      const _id1n = _hm.n(_id1);
      const _id2n = _hm.n(_id2);
      if (_id1n > _id2n) return  1;
      if (_id1n < _id2n) return -1;
      return 0;
    });

  let _prtRoomId = '';
  let _cldRoomId = '';
  _roomIds.map((_roomId: _ht.s, _idx: _ht.n) => {
    if (_idx == 0) {
      _prtRoomId += _roomId;
    }
    else {
      _cldRoomId += (_cldRoomId == '' ? '' : ';') + _roomId;
    }
  });
  const _dz = {
    prtRoomId: _prtRoomId,
    cldRoomId: _cldRoomId,
  };
  return _dz;
}

export const udtTime = (i1zz: _ht.dz, i17rs?: _ht.ls) => {
  let _nTimeStt = 24;
  let _nTimeEnd = 0;
  i1zz.i1z1s.map((_i1z1z: _ht.dz) => {
    if (_i1z1z._dlt != 1) {
      if (_i1z1z.i1z1a1100i < _nTimeStt) _nTimeStt = _i1z1z.i1z1a1100i;
      if (_i1z1z.i1z1a1200i > _nTimeEnd) _nTimeEnd = _i1z1z.i1z1a1200i;
    }
  });
  i1zz.i1zrz.i1zrd4100i = _nTimeStt;
  i1zz.i1zrz.i1zrd4200i = _nTimeEnd;

  if (i17rs) {
    i1zz.i1z2s?.map((_i1z2z: _ht.dz) => {
      const _i17rz = _hm.getDz(i17rs, _i1z2z.i1z2i17r1f, "_fst");
      const _nFee =
        _i17rz?.i17rt1100i == 20
          ? (_nTimeEnd - _nTimeStt) * _i17rz?.i17rm1100i
          : _i17rz?.i17rm1100i;
      _i1z2z.i1z2m1100i = _nFee;
      _i1z2z.i1z2a1100i = _nTimeStt;
      _i1z2z.i1z2a1200i = _nTimeEnd;
    });
  }
};

export const udtI1z3z = (pz: {
  i1zz: _ht.dz;
  i17rs: _ht.ls;
  role?: "s" | "d";
}) => {
  udtTime(pz.i1zz, pz.i17rs);

  let _i1z3m1110i = 0; // 利用料合計（部屋）
  pz.i1zz.i1z1s?.map((_i1z1z: _ht.dz) => {
    if (_i1z1z._dlt != 1) {
      _i1z3m1110i += _i1z1z.i1z1m1100i ?? 0;
    }
  });
  let _i1z3m1120i = 0; // 利用料合計（備品・駐車場）
  pz.i1zz.i1z2s?.map((_i1z2z: _ht.dz) => {
    if (_i1z2z._dlt != 1) {
      _i1z3m1120i += _i1z2z.i1z2m1100i ?? 0;
    }
  });

  const _i1z3m2100i = // 減免額 部屋：i1z3m1110i のみが対象
    pz.i1zz.i1z3z?.i1z3t1100i == 50
      ? Number(_i1z3m1110i * 0.5).toFixed(0)
      : pz.i1zz.i1z3z?.i1z3t1100i == 100
      ? _i1z3m1110i
      : pz.i1zz.i1z3z?.i1z3t1100i == 999 && pz.role == "d" // その他
      ? (_hm.n(pz.i1zz.i1z3z.i1z3m1110i) * _hm.n(pz.i1zz.i18rz.i18raa200i)) / 100
      : pz.i1zz.i1z3z?.i1z3t1100i == 999 && pz.role != "d" // その他
      ? pz.i1zz.i1z3z?.i1z3m2100i ?? 0
      : 0;

  const _i1z3m3100i = pz.i1zz.i1z3z?.i1z3m3100i ?? 0; // その他金額

  const _i1z3m4100i = _i1z3m1110i + _i1z3m1120i + _i1z3m3100i - _i1z3m2100i; // 支払額合計

  const _i1z3s1100i =
    _i1z3m4100i == 0 ? 0 : _hm.f(pz.i1zz.i1z3z?.i1z3d2100s) ? 40 : 20;

  const _i1z3z = {
    i1z3m1110i: _i1z3m1110i,
    i1z3m1120i: _i1z3m1120i,
    i1z3m2100i: _i1z3m2100i,
    i1z3m3100i: _i1z3m3100i,
    i1z3m4100i: _i1z3m4100i,
    i1z3s1100i: _i1z3s1100i,
  };

  if (!pz.i1zz.i1z3z) pz.i1zz.i1z3z = {};
  _hm.udtDz(pz.i1zz.i1z3z, _i1z3z);

  return _i1z3z;
};

export const getTime = (pz: {
  // 開始・終了時刻の取得
  i1zrd3100s: _ht.s, // date
  i111_fst: _ht.n, // その他１時間の特定に必要
  i111z: _ht.dz, // 開始終了時刻の取得元
  i11ra1100i: _ht.n, // 夏時間の特定に必要
  i11ra1200i: _ht.n, // 夏時間の特定に必要
  i15ra6100i?: _ht.n, // １種・２種の特定に必要
  _601s: _ht.ls,
}) => {
  if (pz.i111_fst == ihv.otrz._fst) {
    // その他１時間
    return {
      stt: 0,
      end: 0,
    };
  }

  const _zoneCtg = pz.i15ra6100i ?? 1;
  const _mthCtg = ihm.getMthCtg({
    date: pz.i1zrd3100s,
    i11ra1100i: pz.i11ra1100i,
    i11ra1200i: pz.i11ra1200i,
  });
  const _dayCtg = ihm.getDayCtg({
    date: pz.i1zrd3100s,
    _601s: pz._601s,
  });

  if (_zoneCtg == 2) {
    // 2種
    if (_mthCtg == "夏時間") {
      // 夏時間
      if (_dayCtg == "日祝") {
        // 日曜
        return {
          ctg: 223,
          stt: pz.i111z.i111a1223i,
          end: pz.i111z.i111a2223i,
        };
      } else if (_dayCtg == "土曜") {
        // 土曜
        return {
          ctg: 222,
          stt: pz.i111z.i111a1222i,
          end: pz.i111z.i111a2222i,
        };
      } else {
        // 平日
        return {
          ctg: 221,
          stt: pz.i111z.i111a1221i,
          end: pz.i111z.i111a2221i,
        };
      }
    } else {
      // 通常
      if (_dayCtg == "日祝") {
        // 日曜
        return {
          ctg: 213,
          stt: pz.i111z.i111a1213i,
          end: pz.i111z.i111a2213i,
        };
      } else if (_dayCtg == "土曜") {
        // 土曜
        return {
          ctg: 212,
          stt: pz.i111z.i111a1212i,
          end: pz.i111z.i111a2212i,
        };
      } else {
        // 平日
        return {
          ctg: 211,
          stt: pz.i111z.i111a1211i,
          end: pz.i111z.i111a2211i,
        };
      }
    }
  } else {
    // 1種
    if (_mthCtg == "夏時間") {
      // 夏時間
      if (_dayCtg == "日祝") {
        // 日曜
        return {
          ctg: 123,
          stt: pz.i111z.i111a1123i,
          end: pz.i111z.i111a2123i,
        };
      } else if (_dayCtg == "土曜") {
        // 土曜
        return {
          ctg: 122,
          stt: pz.i111z.i111a1122i,
          end: pz.i111z.i111a2122i,
        };
      } else {
        // 平日
        return {
          ctg: 121,
          stt: pz.i111z.i111a1121i,
          end: pz.i111z.i111a2121i,
        };
      }
    } else {
      // 通常
      if (_dayCtg == "日祝") {
        // 日曜
        return {
          ctg: 113,
          stt: pz.i111z.i111a1113i,
          end: pz.i111z.i111a2113i,
        };
      } else if (_dayCtg == "土曜") {
        // 土曜
        return {
          ctg: 112,
          stt: pz.i111z.i111a1112i,
          end: pz.i111z.i111a2112i,
        };
      } else {
        // 平日
        return {
          ctg: 111,
          stt: pz.i111z.i111a1111i,
          end: pz.i111z.i111a2111i,
        };
      }
    }
  }
};

export const grtDffz = (pz: { mode: _ht.s; role?: _ht.s }) => {
  const _tgt =
    pz.mode == "r"
      ? "予約"
      : pz.mode == "e"
      ? "エントリー"
      : pz.mode == "s"
      ? "設定変更"
      : pz.mode == "i"
      ? "初期設定"
      : "";
  const _clr =
    pz.role == "s" // staff
      ? pz.mode == "r"
        ? "gn"
        : pz.mode == "e"
        ? "gn"
        : pz.mode == "o"
        ? "gn"
        : "rd"
      : pz.role == "d" // dantai
      ? pz.mode == "r"
        ? "lm"
        : pz.mode == "e"
        ? "bl"
        : pz.mode == "s"
        ? "lt"
        : pz.mode == "i"
        ? "lt"
        : "rd"
      : "rd";
  return {
    tgt: _tgt,
    clr: _clr,
  };
};

export const grtLblz = (pz: { type?: _ht.s; tgt: _ht.s }) => {
  return {
    ttlz: {
      top: `${pz.tgt}一覧`,
      ctt: `${pz.tgt}詳細`,
    },
    msgz: {
      topz: {
        mkr: `【${pz.tgt}詳細の確認／変更】　…`,
        msg: `「確認」ボタンを押すことで詳細画面に移動し、変更もその画面で行えます。`,
      },
      cttz: {
        mkr: `■ 右肩に×のある欄　…`,
        msg: `空欄を押すと選択肢が表示され、×で選択を取り消せます。`,
      },
    },
    btnz: {
      topz: {
        back: "前の画面に戻る",
        new: `${pz.tgt}の新規登録`, // crt に統合予定
        crt: `${pz.tgt}の新規登録`,
        ctt: `確認`,
      },
      cttz: {
        newz: {
          // crt に統合予定
          back: "登録を止める",
          next: `この${pz.tgt}を登録`,
        },
        crtz: {
          back: "登録を止める",
          next: `この${pz.tgt}を登録`,
        },
        showz: {
          // dpyz に統合予定
          back: "前の画面に戻る",
          next: `この${pz.tgt}を変更`,
          ccl: `この${pz.tgt}をキャンセル`,
          dlt: `この${pz.tgt}を削除`,
        },
        dpyz: {
          back: "前の画面に戻る",
          next: `この${pz.tgt}を変更`,
          ccl: `この${pz.tgt}をキャンセル`,
          dlt: `この${pz.tgt}を削除`,
        },
        editz: {
          // udt に統合予定
          back: "変更を止める",
          next: `この${pz.tgt}の変更を反映`,
        },
        udtz: {
          back: "変更を止める",
          next: `この${pz.tgt}の変更を反映`,
        },
      },
    },
  };
};

export const ilzPagezAsync = async (_31r_fst: _ht.n, pagez: _ht.dz, schz?: _ht.dz, i18r_fst?: _ht.n) => {
  _hm.udtDz(pagez, {
    bLoad: true,
    bSch: false,
    i1zrs: [],
    i10rs: [],
    i10r_fsts: [],
    i17rs: [],
    i15rs: [],
    i18rz: {},
    hdys: [],
    schz: { // ホームまたぎでエントリー・予約を表示する場合を考慮し初回のみ初期化
      //_31r_fst: -1, // 施設
      _31r_fst: _31r_fst,
      sttDate: _hmDTM.getTdy(), // 利用日（自）
      endDate: _hmDTM.addDay(_hmDTM.getTdy(), 7), // 利用日（至）
      i18r_fst: -1, // 団体
      i1zrs1100i: 999, // 予約状況
      i1zrs1200i: 999, // エントリ状況
      ... schz,
    },
  });
//  await _hm.ectPrlAsync([
  await _hm.ectSrlAsync([
    async () => {
      const _dz = ihdI10.grtPzForLoadI10rPs(_cm.grtUz(), { // 部屋
        _31r_fst: _31r_fst,
        i18r_fst: i18r_fst,
        lwrz: {
          i11rs: true,
          i111s: true,
          i101s: true,
          i102s: true,
          i10rsAll: true,
        },
      })
//      _hm.l(`icm 750a: ${_hm.s(_dz)}`)
      pagez.i10rs = await _cmFTH.loadLsAsync(_dz);
//      pagez.i10rs.map((i10rz: _ht.dz) => {
//        _hm.l(`icm 750a: ${i10rz._fst}, ${_hm.s({ ... i10rz, cldz: undefined })}`)
//        _hm.l(`icm 750b: ${i10rz._fst}`)
//      })

      pagez.i10r_fsts = pagez.i10rs.map((_i10rz: _ht.dz) => _i10rz._fst);

    },
    async () => {
      pagez.i17rs = await _cmFTH.loadLsAsync(ihdI17.grtPzForLoadI17rPs(_cm.grtUz(), { // 備品・駐車場
        _31r_fst: _31r_fst,
        i18r_fst: i18r_fst,
      }));
    },
    async () => {
      pagez.i15rs = await _cmFTH.loadLsAsync(ihdI15.grtPzForLoadI15rPs(_cm.grtUz(), { // 団体種別
        _31r_fst: _31r_fst,
        lwrz: {
          i18rs: false,
          i1zrs: false,
          i1z1s: false,
          i1z4s: false,
        }
      }));
    },
    async () => {
      const _601s = await _cmFTH.loadLsAsync(_hd_60.grtPzForLoad_601Ps(_cm.grtUz())); // 祝日
      pagez.hdys = _601s.map((_601z: _ht.dz) => _601z._icn);
    },
  ]);
};

export const loadAtTopAsync = async (pz: {
  _31r_fst: _ht.n;
  frcUdt?: () => void;
  atrAsync?: () => void;
  vles?: _ht.ls;
}) => {
  const _gUserz = gs.useUserz();
  React.useEffect(() => {
    setStgzAsync({
      _31r_fst: pz._31r_fst,
      i18r_fst: _gUserz.crt.i18rz?._fst,
    }).then(async () => {
      if (pz?.atrAsync) await pz?.atrAsync();
      if (pz?.frcUdt) await pz?.frcUdt();
    }); // stgz の更新
  }, pz.vles ?? [pz._31r_fst, _gUserz.crt.i18rz?._fst]);
};

export const loadAtCttAsync = (pz: {
  _31r_fst: _ht.n;
  i18r_fst?: _ht.n;
  frcUdt?: () => void;
  atrAsync?: () => void;
}) => {
  // stgz の更新
  React.useEffect(() => {
    setStgzAsync({
      _31r_fst: pz._31r_fst,
      i18r_fst: pz?.i18r_fst,
    }).then(async () => {
      if (pz?.atrAsync) await pz?.atrAsync();
      if (pz?.frcUdt) await pz?.frcUdt();
    }); // stgz の更新
  }, []);
};

export const lgt = async (pz?: { bTimeOut?: _ht.b }) => {
  // logout

  const _sNgnz = useNgnz();
  _sNgnz.getNameAsync().then(async (_name: _ht.s) => {
    if (!_hm.i(_name, ["stt", "sng", "i", "icvLgnS10Rz"])) {
      // 予約状況・サイネージはログアウト対象外

      const _gUserz = gs.useUserz();
      const _gStgz = gs.useStgz();

      const __10rt1100i = _gUserz.crt._10rz?._10rt1100i; // 利用者区分
      const _i19ra1110s = _gUserz.crt.i19rz?.i19ra1110s; // スタッフ用ドメイン
      const _i19ra1210s = _gUserz.crt.i19rz?.i19ra1210s; // 団体用ドメイン

      if (pz?.bTimeOut && __10rt1100i == 20) {
        // タイムアウトでスタッフの場合
        cr.moveTo({
          pageName: "icvLgnS20Rz",
        });
      } else {
        // タイムアウトでスタッフ以外の場合、タイムアウトでない場合

        const _userz = {
          // 個人・団体に依存する情報をクリア
          ..._gUserz.crt,
          _31rz: undefined,
          _10rz: undefined,
          i18rz: undefined,
          i15rz: undefined,
        };

        await _gUserz.rmvAsync();
        await _gStgz.rmvAsync();
        await cmLSG.rmvAllAsync();

        await _gUserz.saveAsync(_userz);

        if (__10rt1100i == 90) {
          // 管理者
          cr.moveTo({
            pageName: "i",
            pmrz: {
              d: icv.appz.dmnNameOrn,
            },
          });
        } else if (__10rt1100i == 20) {
          // スタッフ
          cr.moveTo({
            pageName: "i",
            pmrz: {
              d: _i19ra1110s,
            },
          });
        } else if (__10rt1100i == 10) {
          // 団体
          cr.moveTo({
            pageName: "i",
            pmrz: {
              d: _i19ra1210s,
            },
          });
        } else {
          // 団体
          cr.moveTo({
            pageName: "i",
          });
        }
      }
    }
  });
};

export const grtBccs = () => { // 団体の所属施設でなく 部屋の所属施設に送信
  const _bccs = [] as _ht.ls;
  if (_hm.f(e.mailz.bcc)) _bccs.push(e.mailz.bcc);
  return _bccs;
};

/**
@param sjt 件名
@param msg 本文
@param i18r_fst 団体
@param _31r_fst 団体の登録施設でなく利用施設
 */
export const grtMailzAsync2 = async (pz: {
  sjt: _ht.s;
  msg: _ht.s;
  i18r_fst: _ht.n;
  _31r_fst: _ht.n;
}) => {

  const _dz = {
    i18rz: {} as _ht.dz,
    _31rz: {} as _ht.dz,
    i191z: {} as _ht.dz,
    S01050111: '',
    S01050212: '',
  };
  await _hm.ectPrlAsync([
    async () => {
      const _i18z = await icvI18___Mz.loadI18rDzAsync({
        i18r_fst: pz.i18r_fst,
      });
      _dz.i18rz = _i18z?.i18rz;
    },
    async () => {
      const __31z = await _cv_31___Mz.load_31rDzAsync({
        _31r_fst: pz._31r_fst,
      });
      _dz._31rz = __31z?._31rz;
    },
    async () => {
      const _i19z = await icvI19___Mz.loadI191DzAsync({
        _31r_fst: pz._31r_fst,
      });
      _dz.i191z = _i19z?.i191z;
    },
    async () => {
      const _51rz = await _cv_51___Mz.load_51rDzAsync({
        _31r_fst: pz._31r_fst,
        _50r_icn: 'S01050111',
      });
      _dz.S01050111 = _51rz?._51rz?._51ra1100t ?? '';
    },
    async () => {
      const _51rz = await _cv_51___Mz.load_51rDzAsync({
        _31r_fst: pz._31r_fst,
        _50r_icn: 'S01050212',
      });
      _dz.S01050212 = _51rz?._51rz?._51ra1100t ?? '';
    },
  ]);

  const _tos = [] as _ht.ls;
  if (_hm.f(_dz.i18rz.i18ra4110s)) _tos.push(_dz.i18rz.i18ra4110s); // 団体のメールアドレス1
  if (_hm.f(_dz.i18rz.i18ra4210s)) _tos.push(_dz.i18rz.i18ra4210s); // 団体のメールアドレス2
  if (_hm.f(_dz.i18rz.i18ra4310s)) _tos.push(_dz.i18rz.i18ra4310s); // 団体のメールアドレス3

  const _bccs = grtBccs();
  if (_dz.S01050212) _bccs.push(_dz.S01050212);

  const _sjt = pz.sjt + `(${_dz._31rz._pfx})`;

  const _msg = `
団体番号：${_dz.i18rz?.i18rab100s ?? ""}
${_dz.i18rz?._pfx ?? ""}　様

-------------------------------------------------
${pz.msg}
-------------------------------------------------

${_dz.S01050111 ?? ""}
`;

  const _user = _hm.f(_dz.i191z?.i191a4110s) ? _dz.i191z?.i191a4110s : undefined;
  const _pwd = _hm.f(_dz.i191z?.i191a4120s) ? _dz.i191z?.i191a4120s : undefined;

  const _mailz = {
    fromName: _dz._31rz._pfx,
    tos: _tos,
    bccs: _bccs,
    sjt: _sjt,
    msg: _msg,
    user: _user,
    pwd: _pwd,
  };
  return _mailz;
};

/*
let $bEtl = false; // 連携状況
let $bUdt = false; // 保存状況
*/

/**
  @todo iptz を削除し iptz2 に寄せる
 */
export const sendEtlAsync = async (pz: { // エントリー抽選のため ism にも同様の処理あり <- 重複登録のチェック処理はない
  //外部連携
  i1zz: _ht.dz;
  i10rs: _ht.ls,
  i17rs: _ht.ls,
  i15rs: _ht.ls,
  i18rz: _ht.dz,
  hdys: _ht.ls,
  ctt: "e" | "r";
  chkStep: _ht.n;
  sCfmz: _ht.dz;
}) => {
  // 本来はサーバー側で事項すべきであるが DB 処理がサーバー側に一元化されていないため 一部 クライアント側で実行

  //_hm.l(`icm.sendEtlAsync 1509a: ${_hmDTM.getNow()}`);
  const _i1zz = await icvI1z___Mz.saveI1zrDzAsync({
    // 外部連携を遅延クエリとするため、先に登録
    i1zz: pz.i1zz,
    i10rs: pz.i10rs,
    i17rs: pz.i17rs,
    i15rs: pz.i15rs,
    i18rz: pz.i18rz,
    hdys: pz.hdys,
  });
  //_hm.l(`icm.sendEtlAsync 1509b: ${_hmDTM.getNow()}`);

  let _bChkRsvDct = true;
  await _hm.ectPrlAsync( // icvI1z___Mz.chkI1zAsyn にも同様の処理あり
    icm.getI1z1Atv(_i1zz.i1z1s) // 空欄以外 かつ 未削除
    .map((_i1z1z: _ht.dz) => async () => {
      //_hm.l(`icvI1z___Mz 831b: ${_hm.s(_i1z1z)}`);
      const _dz2 = { // これが重い
        _31r_fst: _i1zz.i1zrz.i1zr_31r1f,
        i10r_fst: _i1z1z.i1z1i10r1f,
        i1zr_fst: _i1zz.i1zrz._fst, // 自身を除く 1/2
        i1zrs1100iMnm: 70,
        i1zrd3100s: _i1zz.i1zrz.i1zrd3100s,
        i1z1a1100i: _i1z1z.i1z1a1100i,
        i1z1a1200i: _i1z1z.i1z1a1200i,
        fld: '*',
        lwrType: 1, // i1zrz を含む
      };
      const _ls = await icvI1z___Mz.loadI1z1LsAsync(_dz2);
      //_hm.l(`icvI1z___Mz 831c: ${_hm.s(_dz2)}`);
      //_hm.l(`icvI1z___Mz 831d: ${_hm.s(_ls)}`);
      //if (_ls.length > 0) _bChkRsvDct = false;
      _ls.map((dz: _ht.dz) => {
        const _i1zrz = dz.cldz.i1zrs[0];
        if (_hm.n(_i1zz.i1zrz._icn) >= _hm.n(_i1zrz._icn)) {
          _bChkRsvDct = false;
        }
//        _hm.l(`icm 1014: ${_hm.s(dz)}`);
      })
    })
  )

  if (_bChkRsvDct != true) { // 重複データが存在する場合は処理を終了
    _hm.udtDz(_i1zz.i1zrz, {
      i1zrs1100i: 22,
    });
    await icvI1z___Mz.saveI1zrDzAsync({
      // 外部連携を遅延クエリとするため、先に登録
      i1zz: _i1zz,
      i10rs: pz.i10rs,
      i17rs: pz.i17rs,
      i15rs: pz.i15rs,
      i18rz: pz.i18rz,
      hdys: pz.hdys,
    });
    pz.sCfmz.show({
      pfx: "只今お申し込みが集中しており、お手続きでエラーが発生しました。お手数をおかけしますが、もう一度手続きをやり直してください。",
      ls: [
        { key: 1, pfx: "はい" },
      ]
    });
    return undefined;
  }

  const _tgtI1zz =
    pz.i1zz.i1zrz._dlt == 1 // 削除は削除前のデータ元に処理
      ? pz.i1zz
      : _i1zz; // 追加・更新は登録後のデータを元に処理

  // 外部連携を使用　かつ yflg が設定されている場合のみ実行
  const _gUserz = gs.useUserz();
  const _i19rz = _gUserz.crt.i19rz;
  const _i1zrz = _tgtI1zz.i1zrz;
  const _i1z4z = _tgtI1zz.i1z4z;
  //_hm.l(`icm.sendEtlAsync 1526a: ${_hmDTM.getNow()}`);
  const _i18z = await icvI18___Mz.loadI18rDzAsync({
    i18r_fst: _i1zrz.i1zri18r1f,
  });
  //_hm.l(`icm.sendEtlAsync 1526b: ${_hmDTM.getNow()}`);
  const _i18rz = _i18z.i18rz;
  const _i15rz = _i18z.i15rz;
  const _i1z3z = _tgtI1zz.i1z3z;
  let _yflg =
    _i1zrz._dlt == 1 ? // 削除
      "-2"
    : _i1zrz.i1zrs1100i == 22 ? // キャンセル済・仮予約
      "-2"
    : _i1zrz.i1zrs1100i == 24 ? // キャンセル済・返金あり
      "-1"
    : _i1zrz.i1zrs1100i == 26 ? // キャンセル済・返金なし
      "0"
    : _i1zrz.i1zrs1100i == 80 && _i15rz.i15ra7100i == 910 ? // 予約不可
      "3"
    : _i1zrz.i1zrs1100i == 80 && _i15rz.i15ra7100i == 110 ? // 一般利用
      "1"
    : _i1zrz.i1zrs1100i == 80 && _i15rz.i15ra7100i == 920 ? // 個人利用
      "4"
    : _i1zrz.i1zrs1100i == 80 && _i15rz.i15ra7100i == 930 ? // 老福利用
      "5"
    : _i1zrz.i1zrs1100i == 90 && _i15rz.i15ra7100i == 910 ? // 予約不可
      "3"
    : _i1zrz.i1zrs1100i == 90 && _i15rz.i15ra7100i == 110 ? // 一般利用
      "2"
    : _i1zrz.i1zrs1100i == 90 && _i15rz.i15ra7100i == 920 ? // 個人利用
      "4"
    : _i1zrz.i1zrs1100i == 90 && _i15rz.i15ra7100i == 930 ? // 老福利用
      "5"
    : ""; // 1: 仮予約, 2: 一般予約, 3: 予約不可, 4: 個人利用, 5: 老福利用, 0: キャンセル返金なし, -1: キャンセル返金あり, -2: 削除

  if (
    pz.ctt == "r" &&
    pz.chkStep == 3 &&
    _i19rz.i19ra2410i == 1 &&
    _hm.f(_yflg)
  ) { // 外部連携を行う場合
    const _i10rs = [] as _ht.ls;
//    let _genFeeTtl = 0; 
//    let _ryokinTtl = 0; 
    //_hm.l(`icm.sendEtlAsync 1570a: ${_hmDTM.getNow()}`);
    await _hm.ectPrlAsync(
      _tgtI1zz.i1z1s // 削除処理に対応するため、_i1zz ではなく pz.i1zz
      .filter((_i1z1z: _ht.dz) =>
        ((_i1z1z._dlt == 1 && !_hm.f(_i1zrz.i1zra7100s)) || !_hm.f(_i1z1z)) ? false : true
      )
      .map((_i1z1z: _ht.dz) => async () => {
        const _i10z = await icvI10___Mz.loadI10rDzAsync({ // 複合部屋の場合は子部屋の部屋IDが必要
          i10r_fst: _i1z1z.i1z1i10r1f,
        });
        if (_i10z.i10rz.i10rt1100i == 20) { // 複合部屋
          _i10z.i102s.map((_i102z: _ht.dz) => {
            _i102z.cldz.i10rs.map((_i10rz: _ht.dz) => {
              _i10rs.push(_i10rz);
            })
          });
        }
        else { // 単体部屋
          _i10rs.push(_i10z.i10rz);
        }
/*
        const _genFee = _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
          ? 0
          : (_i1z1z.i1z1m1100i * _i1z3z.i1z3m2100i) /
            (_i1z3z.i1z3m1110i ?? _i1z3z.i1z3m2100i);
        _genFeeTtl += _genFee;
*/
/*
        const _ryokin = _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
          ? 0
          : _i1z1z.i1z1m1100i - _genFee;
        _ryokinTtl += _ryokin;
*/
        return true;
      })
    );

/*
    const _genmenflg = _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
      ? ""
      : _i1z3z.i1z3t1100i == 100
      ? "1"
      : _i1z3z.i1z3t1100i == 50
      ? "2"
      : _i1z3z.i1z3t1100i == 999
      ? "3"
      : ""; // 空欄: なし、1:10割, 2:5割, 3:他
    const _reason = _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
      ? ""
      : _i1z3z.i1z3t2100i == 10
      ? "A"
      : _i1z3z.i1z3t2100i == 20
      ? "B"
      : _i1z3z.i1z3t2100i == 30
      ? "C"
      : _i1z3z.i1z3t2100i == 40
      ? "D"
      : "";
    const _yuusen = _i1zrz.i1zrt1100i == 1 ? "1" : ""; // 1: 優先, 空欄: 対象外
    const _koukai =
      _i19rz.i19ra2420i == 10
        ? "0"
        : _i19rz.i19ra2420i == 20
        ? "1"
        : _i19rz.i19ra2420i == 30
        ? "2"
        : ""; // 0: 非公開, 1: 申込団体を表示, 2: 目的を表示
    const _roomIdz = grtRoomIdz(_i10rs);
    const _s0 = _i1z4z.i1z4a1100i ?? 0;
    const _s1 = _i1z4z.i1z4a1200i ?? 0;
    const _s2 = _s0 + _s1;
    const _m1 = _i1z4z.i1z4a2100i ?? 0;
    const _m2 = _i1z4z.i1z4a2200i ?? 0;
    const _m3 = _i1z4z.i1z4a2300i ?? 0;
    const _m4 = _i1z4z.i1z4a2400i ?? 0;
    const _m5 = _i1z4z.i1z4a2500i ?? 0;
    const _m6 = _i1z4z.i1z4a2600i ?? 0;
    const _f6 = _i1z4z.i1z4a2700i ?? 0;
    const _m7 = _i1z4z.i1z4a2800i ?? 0;
    const _f7 = _i1z4z.i1z4a2900i ?? 0;
    const _mf = _m1 + _m2 + _m3 + _m4 + _m5 + _m6 + _f6 + _m7 + _f7;

    const _kunai = _i1z4z.i1z4a3100i ?? 0;
    const _kugai = _i1z4z.i1z4a3200i ?? 0;
    const _shigai = _i1z4z.i1z4a3300i ?? 0;
    const _ssk = _kunai + _kugai + _shigai;
*/
    const _gStgz = gs.useStgz();

/*
    const _iptz = {
      login: _gStgz.crt.S91999112,
      password: _gStgz.crt.S91999122,
      date: _i1zrz.i1zrd3100s,
      rsvid: _i1zrz.i1zra7100s, // 新規登録時は 0
      start: _i1zrz.i1zrd4100i,
      end: _i1zrz.i1zrd4200i,
      genFee: _genFeeTtl,
      yflg: _yflg,
      dname: String(_i18rz._pfx).replace(/ /g, "%20"),
      title: _i1zrz.i1zra4100s,
      ryokin: _ryokinTtl,
      feefree: "", // 料金手動入力
      rcvdate: _i1z3z.i1z3d2100s,
      genmenflg: _genmenflg,
      reason: _reason,
      bikou: _i1zrz._ctn,
      yuusen: _yuusen,
      roomid: _roomIdz.prtRoomId,
      childRoomid: _roomIdz.cldRoomId,
      koukai: _koukai,
      s0: _s0, // 男性
      s1: _s1, // 女性
      s2: _s2, // 合計
      m1: _m1, // 幼児
      m2: _m2, // 小学生
      m3: _m3, // 中学生
      m4: _m4, // 高校生
      m5: _m5, // 大学生
      m6: _m6, // 一般男性
      f6: _f6, // 一般女性
      m7: _m7, // 65歳以上男性
      f7: _f7, // 65歳以上女性
      mf: _mf, // 合計
      kunai: _kunai, // 区内
      kugai: _kugai, // 区外
      shigai: _shigai, // 市内
      ssk: _ssk, // 合計
    };
*/

    const _iptz2 = await ihm.grtEtlDataAsync({
      i1zrz: _i1zrz, 
      i1z1s: _tgtI1zz.i1z1s, 
      i1z3z: _i1z3z, 
      i1z4z: _i1z4z, 
      i10rs: _i10rs, // 部屋（子部屋を含む）
      i15rz: _i15rz, // 団体種別
      i18rz: _i18rz, // 団体
      i19rz: _i19rz, // クライアント
      S91999112: _gStgz.crt.S91999112,
      S91999122: _gStgz.crt.S91999122,
    });

    await _cmFTH.sendClwAsync({
      _a0rt1110i: 30,
      _a0ra1110t: _hm.s({
        ipt: encodeURIComponent(_hm.s(_iptz2)), // 外部連携時の文字化けを防ぐ
        i1zrz: _i1zrz,
        S01050212: _gStgz.crt.S01050212,
      }),
    });

  }
  return _i1zz;
};

export const saveI1zzAddAsync1 = (pz: {
  // 通常登録の場合
  role: "s" | "d",
  ctt: "r" | "e",
  i1zz: _ht.dz,
  i10rs: _ht.ls,
  i17rs: _ht.ls,
  i15rs: _ht.ls,
  i18rz: _ht.dz,
  hdys: _ht.ls,
  _31r_fst: _ht.n,
  chkStep: _ht.n,
  bfrAsync?: () => Promise<_ht.b>,
  atrAsync: (_dz: _ht.dz) => void,
  sMsgz: _ht.dz,
  sLdrz: _ht.dz,
  sCfmz: _ht.dz,
  sPz?: _ht.dz,
  phs?: _ht.s, // phase
}) =>
  new Promise(async (_exit) => {
    //_hm.l(`icm 1755a: ${_hmDTM.getNow()}`);

    const _gStgz = gs.useStgz();

    pz.sLdrz.show();
    //_hm.l(`icm 1760a: ${_hmDTM.getNow()}`);
    const _b = await icvI1z___Mz.chkI1zAsync({ // 事前チェック処理
      role: pz.role,
      ctt: pz.ctt,
      _31r_fst: pz._31r_fst,
      i1zz: pz.i1zz,
      i10rs: pz.i10rs,
      i17rs: pz.i17rs,
      sMsgz: pz.sMsgz,
      step: pz.chkStep,
    });
    //_hm.l(`icm 1760b: ${_hmDTM.getNow()}`);

    if (_b) {

      //_hm.l(`icm 1878a: ${_hm.s(pz.i1zz)}`);
      if (pz.chkStep == 3) {
        await udtFeeAsync ({ // 原因不明の利用料の相違に対応するため、保存直前に利用料を最新化
          i1zz: pz.i1zz,
        });
      }
      //_hm.l(`icm 1878b: ${_hm.s(pz.i1zz)}`);

      if (pz.bfrAsync) {
        pz.sLdrz.hide();
        //_hm.l(`icm 1781a: ${_hmDTM.getNow()}`);
        const _b2 = await pz.bfrAsync();
        //_hm.l(`icm 1781b: ${_hmDTM.getNow()}`);
        if (_b2 == false) {
          _exit(false);
        } else {
          pz.sLdrz.show();
        }
      }
      if (pz.chkStep == 1) {
        // 仮押
        _hm.udtDz(pz.i1zz.i1zrz, {
          i1zrs1100i: pz.ctt == "r" ? 70 : pz.ctt == "e" ? 10 : undefined,
          i1zrs1200i: pz.ctt == "r" ? 10 : pz.ctt == "e" ? 60 : undefined,
          i1zrd1100s: _hmDTM.getTdy(),
          i1zrd2100s: _hmDTM.getTdy(),
          i1zra6100i: 1, // 経路
        });
        icm.setI1z3d1100s({
          // 支払期限の設定
          i1zz: pz.i1zz,
        });
        icm.udtI1z3z({
          i1zz: pz.i1zz,
          i17rs: [],
        });
      }
      if (pz.chkStep == 3) {
        if (pz.i1zz.i1zrz.i1zrs1100i == 70) {
          // 予約状況が「仮押」の場合
          _hm.udtDz(pz.i1zz.i1zrz, {
            i1zrs1100i: 80,
          });
        }
        if (pz.i1zz.i1zrz.i1zrs1100i == 80 && !_hm.f(pz.i1zz.i1z3z.i1z3d1100s)) {
          // 予約状況が「仮予約」で、支払期限が設定されてない場合
          icm.setI1z3d1100s({
            // 支払期限の設定
            i1zz: pz.i1zz,
          });
        }
        if (pz.i1zz.i1zrz.i1zrs1200i == 60) {
          _hm.udtDz(pz.i1zz.i1zrz, {
            i1zrs1200i: 70,
          });
        }
      }
      //hf.l(`icm 1300: setState end ${_hmDTM.getNow()}`);
      //hf.l(`icm 1301: sendEtlAsync stt: ${_hmDTM.getNow()}`);
      //_hm.l(`icm 1830a: ${_hmDTM.getNow()}`);
      const _i1zz = await sendEtlAsync({ // この処理が重い
        i1zz: pz.i1zz, // _i1zz では削除した明細行が含まれない
        i10rs: pz.i10rs,
        i17rs: pz.i17rs,
        i15rs: pz.i15rs,
        i18rz: pz.i18rz,
        hdys: pz.hdys,
        ctt: pz.ctt,
        chkStep: pz.chkStep,
        sCfmz: pz.sCfmz,
      });
      //_hm.l(`icm 1830b: ${_hmDTM.getNow()}`);
      //hf.l(`icm 1308: sendEtlAsync end: ${_hmDTM.getNow()}`);

      if (!_i1zz) { // 重複登録の場合は undefined となり終了
        pz.sLdrz.hide();
        pz.sPz?.set({
          steps: [0],
        });
        _exit(false);
      }
      else {
        //hf.l(`icm 1310: send mail stt: ${_hmDTM.getNow()}`);
        if (pz.chkStep == 3) {
          const _mailz =
            pz.ctt == "r"
              ? ihv.mailz.lz.grtMailRsvAdd({
                  i1zrz: _i1zz?.i1zrz,
                })
              : pz.ctt == "e"
              ? ihv.mailz.lz.grtMailAlyAdd({
                  i1zrz: _i1zz?.i1zrz,
                })
              : {};
          //hf.l(`icm 1760a: ${pz.phs}`)
          if ( 
            pz.role != "s" || 
            ( Number(_gStgz.crt.S01050313) == 1 && pz.phs == 'crt')
          ) {
            //hf.l(`icm 1760b: ${pz.phs}`)
            //_hm.l(`icm 1858a: ${_hmDTM.getNow()}`);
            await gasMailAsync({
              i18r_fst: _i1zz?.i1zrz.i1zri18r1f,
              //_31r_fst: pz._31r_fst,
              _31r_fst: _i1zz?.i1zrz.i1zr_31r1f, // 団体の登録施設でなく利用施設
              sjt: "",
              msg: "",
              ..._mailz,
            });
            //_hm.l(`icm 1858b: ${_hmDTM.getNow()}`);
          }
        }
        pz.sLdrz.hide();
        //_hm.l(`icm 1871a: ${_hmDTM.getNow()}`);
        await pz.atrAsync(_i1zz);
        //_hm.l(`icm 1871b: ${_hmDTM.getNow()}`);
        //hf.l(`icm 1334: send mail end: ${_hmDTM.getNow()}`);
        //hf.l(`icm 1335: saveI1zzAddAsync1 end: ${_hmDTM.getNow()}`);
        //_hm.l(`icm 1755b: ${_hmDTM.getNow()}`);
        _exit(true);
      }
    } else {
      pz.sLdrz.hide();
      //hf.l(`icm 1340: saveI1zzAddAsync1 end: ${_hmDTM.getNow()}`);
      //_hm.l(`icm 1755c: ${_hmDTM.getNow()}`);
      _exit(false);
    }
  });

export const saveI1zzCclAsync1 = (pz: {
  // 通常登録の場合
  role: "s" | "d",
  ctt: "r" | "e",
  i1zz: _ht.dz,
  i10rs: _ht.ls,
  i17rs: _ht.ls,
  i15rs: _ht.ls,
  i18rz: _ht.dz,
  hdys: _ht.ls,
  _31r_fst: _ht.n,
  atrAsync: () => void,
  sCfmz: _ht.dz,
  sLdrz: _ht.dz,
}) =>
  new Promise(async (_exit) => {
    const _gStgz = gs.useStgz();

    pz.sCfmz.show({
      pfx: "キャンセルして良いですか？",
      ls:
        //    pz.ctt == 'r' && pz.role == 's'?
        pz.ctt == "r" && pz.role == "s" && pz.i1zz.i1zrz.i1zrs1100i == 80
          ? [
              { key: 2, pfx: "はい（仮予約）" },
              { key: -1, pfx: "いいえ" },
            ]
          : pz.ctt == "r" && pz.role == "s" && pz.i1zz.i1zrz.i1zrs1100i != 80
          ? [
              { key: 4, pfx: "はい（返金あり）" },
              { key: 6, pfx: "はい（返金なし）" },
              { key: -1, pfx: "いいえ" },
            ]
          : pz.ctt == "r" && pz.role == "d"
          ? [
              { key: 1, pfx: "はい" },
              { key: -1, pfx: "いいえ" },
            ]
          : pz.ctt == "e"
          ? [
              { key: 1, pfx: "はい" },
              { key: -1, pfx: "いいえ" },
            ]
          : undefined,
      onPrs: async (_n: _ht.n) => {
        if (_n > 0) {
          pz.sLdrz.show();
          if (pz.ctt == "r") {
            const _gStgz = gs.useStgz();
            const _drc = _hmDTM.getDrcDay(
              _hmDTM.getTdy(),
              pz.i1zz.i1zrz.i1zrd3100s
            );

            if (pz.role == "s" && _n == 2) {
              // 仮予約のキャンセル
              // スタッフ・仮予約の場合
              _hm.udtDz(pz.i1zz.i1zrz, {
                i1zrs1100i: 22,
              });
              _hm.udtDz(pz.i1zz.i1z3z, {
                i1z3s2100i: 20, // 未収金
              });
            }
            if (pz.role == "s" && _n == 4) {
              // 本予約のキャンセル（返金あり）
              // スタッフ・返金ありの場合
              _hm.udtDz(pz.i1zz.i1zrz, {
                i1zrs1100i: 24,
              });
              _hm.udtDz(pz.i1zz.i1z3z, {
                i1z3s2100i: 30, // 返金済
              });
            }
            if (pz.role == "s" && _n == 6) {
              // 本予約のキャンセル（返金なし）
              // スタッフ・返金なしの場合
              _hm.udtDz(pz.i1zz.i1zrz, {
                i1zrs1100i: 26,
              });
              _hm.udtDz(pz.i1zz.i1z3z, {
                i1z3s2100i: 10, // 集金済
              });
            }
            if (pz.role == "d") {
              // 団体の場合
              _hm.udtDz(pz.i1zz.i1zrz, {
                i1zrs1100i: 22,
              });
              _hm.udtDz(pz.i1zz.i1z3z, {
                i1z3s2100i: 20, // 返金あり（集金なし）
              });
            }
          }
          if (pz.ctt == "e") {
            _hm.udtDz(pz.i1zz.i1zrz, {
              i1zrs1200i: 20,
            });
          }

          const _i1zz = await sendEtlAsync({
            i1zz: pz.i1zz,
            i10rs: pz.i10rs,
            i17rs: pz.i17rs,
            i15rs: pz.i15rs,
            i18rz: pz.i18rz,
            hdys: pz.hdys,
            ctt: pz.ctt,
            chkStep: 3,
            sCfmz: pz.sCfmz,
          });
          if (!_i1zz) { // 重複登録のあった場合は undefined
            pz.sLdrz.hide();
          }
          else {
            const _mailz =
              pz.ctt == "r"
                ? ihv.mailz.lz.grtMailRsvCcl({
                    i1zrz: _i1zz.i1zrz,
                  })
                : pz.ctt == "e"
                ? ihv.mailz.lz.grtMailAlyCcl({
                    i1zrz: _i1zz.i1zrz,
                  })
                : {};

            if (pz.role != "s" || Number(_gStgz.crt.S01050313) == 1) {
              await gasMailAsync({
                i18r_fst: _i1zz.i1zrz.i1zri18r1f,
                //_31r_fst: pz._31r_fst,
                _31r_fst: _i1zz.i1zrz.i1zr_31r1f,
                sjt: "",
                msg: "",
                ..._mailz,
              });
            }
            pz.sLdrz.hide();
            pz.atrAsync();
          }

        }
      },
    });
  });

export const saveI1zzDltAsync1 = (pz: {
  // 通常登録の場合
  i1zz: _ht.dz,
  i10rs: _ht.ls,
  i17rs: _ht.ls,
  i15rs: _ht.ls,
  i18rz: _ht.dz,
  hdys: _ht.ls,
  atrAsync: () => void,
  ctt: "e" | "r",
  sCfmz: _ht.dz,
  sLdrz: _ht.dz,
}) =>
  new Promise(async (_exit) => {
    pz.sCfmz.show({
      pfx: "削除して良いですか？",
      onPrs: async (_n: _ht.n) => {
        if (_n == 1) {
          pz.sLdrz.show();
          _hm.udtDz(pz.i1zz.i1zrz, {
            i1zrs1100i: 10,
            i1zrs1200i: 10,
            _dlt: 1,
          });
          /*
        await icvI1z___Mz.saveI1zrDzAsync({
          i1zz: pz.i1zz
        });
        if ( pz.ctt == 'r' ) {
          await sendEtlAsync({
            i1zz: pz.i1zz,
          });
        }
*/
          await sendEtlAsync({
            i1zz: pz.i1zz,
            i10rs: pz.i10rs,
            i17rs: pz.i17rs,
            i15rs: pz.i15rs,
            i18rz: pz.i18rz,
            hdys: pz.hdys,
            ctt: pz.ctt,
            chkStep: 3,
            sCfmz: pz.sCfmz,
          });
          pz.sLdrz.hide();
          pz.atrAsync();
        }
      },
    });
  });

export const saveI1zzAsync2 = (pz: {// 一括登録の場合
  i1zz: _ht.dz,
  i10rs: _ht.ls,
  i17rs: _ht.ls,
  i15rs: _ht.ls,
  i18rz: _ht.dz,
  hdys: _ht.ls,
  atrAsync: () => void,
  sMsgz: _ht.dz,
  sLdrz: _ht.dz,
  sCfmz: _ht.dz,
}) =>
  new Promise(async (_exit) => {
    if (_hm.f(pz.i1zz.i1z1s)) {
      const _gUserz = gs.useUserz();
      const _gStgz = gs.useStgz();
      pz.sLdrz.show();
      //hf.l(`icm 1501: ${hf.s(pz.i1zz)}`);
      const _i1zs = icm.sltI1zz({ // 利用日ごとに分割
        i1zz: pz.i1zz,
        i17rs: pz.i17rs,
      });
      //hf.l(`icm 1507: ${hf.s(pz.i1zz)}`);
      const _b = await _hm.ectSrlAsync(
        _i1zs.map((_i1zz: _ht.dz) => async () => {
          //hf.l(`icm 1509: ${hf.s(_i1zz)}`);
          const _b = await icvI1z___Mz.chkI1zAsync({
            role: "s",
            ctt: "r",
            _31r_fst: _gUserz.crt._31rz._fst,
            i1zz: _i1zz,
            i10rs: pz.i10rs,
            i17rs: pz.i17rs,
            sMsgz: pz.sMsgz,
            step: 2, // 減免理由がチェックにかかるため、3 はチェックしない
          });
          return _b;
        })
      );
      if (_b) {
        //hf.l(`icm 2018a: here`);
        await _hm.ectSrlAsync(_i1zs.map((_i1zz: _ht.dz) => async () => {
          //hf.l(`icm 2018b: ${hf.s(_i1zz)}`);
          const _i1zz2 = await sendEtlAsync({
            //          i1zz: pz.i1zz,
            i1zz: _i1zz,
            i10rs: pz.i10rs,
            i17rs: pz.i17rs,
            i15rs: pz.i15rs,
            i18rz: pz.i18rz,
            hdys: pz.hdys,
            ctt: "r",
            chkStep: 3,
            sCfmz: pz.sCfmz,
          });
          //hf.l(`icm 2018c: ${hf.s(_i1zz2)}`);

          if (!_i1zz2) { // 重複登録の場合は undefined
          }
          else {
            const _mailz = ihv.mailz.lz.grtMailRsvAdd({
              // メール送信
              i1zrz: _i1zz2.i1zrz,
            });
            //hf.l(`icm 2018d: ${hf.s(_mailz)}`);

            //hf.l(`icm 2018e: ${_gStgz.crt.S01050313}`);
            if (Number(_gStgz.crt.S01050313) == 1) {
              //_hm.l(`icm 2122: ${_gUserz.crt._31rz._fst}, ${pz.i1zz.i1zrz.i1zr_31r1f}`);
              await gasMailAsync({
                i18r_fst: pz.i1zz.i1zrz.i1zri18r1f, // undefined になっている
                _31r_fst: _gUserz.crt._31rz._fst, // 一括登録のメール送信のため、登録者の施設でメール送信
                //_31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
                ..._mailz,
              });
              //hf.l(`icm 2018g: here`);
            }
          }
          return true;
        }));
        //hf.l(`icm 1543: here`);
        pz.sLdrz.hide();
        //hf.l(`icm 1545: here`);
        await pz.atrAsync();
        //hf.l(`icm 1547: here`);
        _exit(undefined);
      } else {
        //hf.l(`icm 1551: here`);
        pz.sLdrz.hide();
        _exit(undefined);
      }
    } else {
      //hf.l(`icm 1365: here`);
      pz.sMsgz.show({
        textCz: {
          textz: {
            pfx: "時間帯が選択されたいないため、指定された操作を行うことができまん。",
          },
        },
      });
      _exit(undefined);
    }
  });

/**
@function
@description メールを生成し送付する
@param i18r_fst 団体
@param _31r_fst 団体の登録施設でなく、利用施設
 */
export const gasMailAsync = async (pz: {
  i18r_fst: _ht.n;
  _31r_fst: _ht.n;
  sjt: _ht.s;
  msg: _ht.s;
}) => {
  const _mailz = await grtMailzAsync2(pz);
  //await _cmFTH.sendMailAsync(_mailz);
  await _cmFTH.sendDrtMailAsync(_mailz);
};

export const setDmnAsync = () =>
  new Promise<_ht.b>((_exit1) => {
    const _sNgnz = useNgnz();
    const _gUserz = gs.useUserz();
    //hf.l(`icm 1950: here`);
    _sNgnz.getPmrzAsync("d").then((_dmnName: _ht.s) => {
      //hf.l(`icm 1953: ${_dmnName}`);
      if (_dmnName == icv.appz.dmnNameOrn) {
        //hf.l(`icm 1955: here`);
        _gUserz
          .saveAsync({
            _dmn: 0,
            lgnType: "k",
            i19rz: {},
          })
          .then(() => {
            //hf.l(`icm 1962: here`);
            _exit1(true);
          });
      } else {
        //hf.l(`icm 1967: here`);
        icvI19___Mz
          .loadI19rDzAsync({
            dmnName: _dmnName,
          })
          .then((_i19z: _ht.dz) => {
            //hf.l(`icm 1972: ${hf.s(_i19z)}`);
            if (_hm.f(_i19z.i19rz)) {
              //hf.l(`icm 1974: here`);
              _gUserz
                .saveAsync({
                  _dmn: _i19z.i19rz._dmn,
                  lgnType:
                    _i19z.i19rz.i19ra1110s == _dmnName
                      ? "s"
                      : _i19z.i19rz.i19ra1210s == _dmnName
                      ? `d${_i19z.i19rz.i19ra1220i ?? -1}`
                      : "",
                  i19rz: _i19z.i19rz,
                  _20rz: _i19z._20rz,
                  _801z: _i19z._801z,
                })
                .then(() => {
                  //hf.l(`icm 1988: here`);
                  _exit1(true);
                });
            } else {
              //hf.l(`icm 1993: here`);
              _gUserz
                .saveAsync({
                  _dmn: -1,
                  i19rz: {},
                  _20rz: {},
                  _801z: {},
                })
                .then(() => {
                  //hf.l(`icm 2001: here`);
                  _exit1(false);
                });
            }
          });
      }
    });
  });

export const setLgnAsync = (pz: {
  frcUdt: () => void;
  atrAsync?: () => void;
}) => {
  //hf.l(`icm 2004: here`);
  icm.setDmnAsync().then((_b: _ht.b) => {
    //hf.l(`icm 2007: ${_b}`);
    if (_b) {
      //hf.l(`icm 2009: here`);
      icm.setStgzAsync({
        _31r_fst: 0,
      }).then(async () => {
        //hf.l(`icm 2013: here`);
        if (pz.atrAsync) await pz.atrAsync();
        pz.frcUdt();
      }); // stgz の更新
    }
  });
};

export const setI1z3d1100s = (pz: { // ism にもあり
  // 支払期限
  i1zz: _ht.dz;
}) => {
  const _gStgz = gs.useStgz();
  if (_gStgz.crt.S06010413 == 10) {
    // 支払期限基準が利用日の場合
    pz.i1zz.i1z3z.i1z3d1100s = _hmDTM.addDay(
      pz.i1zz.i1zrz.i1zrd3100s,
      -1 * _gStgz.crt.S06010422
    );
  }
  if (_gStgz.crt.S06010413 == 20) {
    // 支払期限基準が申請日の場合
    pz.i1zz.i1z3z.i1z3d1100s = _hmDTM.addDay(
      pz.i1zz.i1zrz.i1zrd2100s,
      _gStgz.crt.S06010422
    );
  }
};

export const setStgzAsync = async (pz: {
  _31r_fst: _ht.n; // 施設ごとの設定に必要
  i15r_fst?: _ht.n; // 団体種別ごとの設定に必要
  i18r_fst?: _ht.n; // 団体種別ごとの設定に必要
}) => {
  const _gStgz = gs.useStgz();

  const _dz = {} as _ht.dz;

  _dz.tdy = _hmDTM.getTdy();
  _dz.now = _hmDTM.getNow();
  //_dz.tdy = '2024-07-01'; _dz.now = _dz.tdy + ' 00:00:00'; // テスト用

  const _rz = await _cv_51___Mz.load_51rRzAsync({
    _31r_fst: pz._31r_fst,
  });

  if (_hm.f(_rz)) {
    _hm.udtDz(_dz, _rz);

    const _date0Fst = _hmDTM.addMth(_hmDTM.cvtFdm(_dz.tdy), 0);
    const _date1Fst = _hmDTM.addMth(_hmDTM.cvtFdm(_dz.tdy), 1);
    const _date2Fst = _hmDTM.addMth(_hmDTM.cvtFdm(_dz.tdy), 2);
    const _date3Fst = _hmDTM.addMth(_hmDTM.cvtFdm(_dz.tdy), 3);
    const _date4Fst = _hmDTM.addMth(_hmDTM.cvtFdm(_dz.tdy), 4);
    const _date5Fst = _hmDTM.addMth(_hmDTM.cvtFdm(_dz.tdy), 5);
    const _date0Lst = _hmDTM.cvtLdm(_date0Fst);
    const _date1Lst = _hmDTM.cvtLdm(_date1Fst);
    const _date2Lst = _hmDTM.cvtLdm(_date2Fst);
    const _date3Lst = _hmDTM.cvtLdm(_date3Fst);
    const _date4Lst = _hmDTM.cvtLdm(_date4Fst);
    const _date5Lst = _hmDTM.cvtLdm(_date5Fst);
    const _mth0 = _hmDTM.cvtMth(_date0Fst);
    const _mth1 = _hmDTM.cvtMth(_date1Fst);
    const _mth2 = _hmDTM.cvtMth(_date2Fst);
    const _mth3 = _hmDTM.cvtMth(_date3Fst);
    const _mth4 = _hmDTM.cvtMth(_date4Fst);
    const _mth5 = _hmDTM.cvtMth(_date5Fst);
    const _yearMth0 = _hmDTM.f(_date0Fst, "YYYY-MM");
    const _yearMth1 = _hmDTM.f(_date1Fst, "YYYY-MM");
    const _yearMth2 = _hmDTM.f(_date2Fst, "YYYY-MM");
    const _yearMth3 = _hmDTM.f(_date3Fst, "YYYY-MM");
    const _yearMth4 = _hmDTM.f(_date4Fst, "YYYY-MM");
    const _yearMth5 = _hmDTM.f(_date5Fst, "YYYY-MM");

    const _gUserz = gs.useUserz();

//_hm.l(`icm 1928a: here`);
    if (_gUserz.crt.i19rz?.i19ra4100i == 3) {
//_hm.l(`icm 1928b: here`);
      // エントリー期間：３カ月の場合

      const _thisFdm = _hmDTM.cvtFdm(_dz.tdy); // this first day of the month
      const _thisMth = _hmDTM.cvtMth(_dz.tdy); // this first day of the month

      const _baseDrc =
        -1 * ((_thisMth + 1 - ((1 + _gUserz.crt.i19rz.i19ra4200i) % 3)) % 3); // difference with base month
      const _baseFdm = _hmDTM.addMth(_thisFdm, _baseDrc); // this first day of the month
      const _baseMth = _hmDTM.cvtMth(_baseFdm); // this first day of the month

      //hf.l(`icm 2252: ${_dz.tdy}, ${_thisMth}, ${_baseMth}, ${_gUserz.crt.i19rz.i19ra4200i}`);
      const _tgtz =
        _thisMth - _baseMth == 0
          ? {
              alyThisYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 0), "YYYY-MM"), // エントリー年月
              ltyThisYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 1), "YYYY-MM"), // 抽選年月
              tgtThisSttYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 3), "YYYY-MM"), // エントリー対象開始月
              tgtThisEndYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 5), "YYYY-MM"), // エントリー対象開始月
              alyNextYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 3), "YYYY-MM"), // エントリー年月
              ltyNextYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 4), "YYYY-MM"), // 抽選年月
              tgtNextSttYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 6), "YYYY-MM"), // エントリー対象開始月
              tgtNextEndYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 8), "YYYY-MM"), // エントリー対象開始月
              rsvThisOpenYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 1), "YYYY-MM"),
              rsvThisEndYearMthBfrOpen: _hmDTM.f(_hmDTM.addMth(_baseFdm, 2),"YYYY-MM"),
              rsvThisEndYearMthAtrOpen: _hmDTM.f(_hmDTM.addMth(_baseFdm, 2),"YYYY-MM"),
            }
          : _thisMth - _baseMth == 1
          ? {
              alyThisYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 0), "YYYY-MM"), // エントリー年月
              ltyThisYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 1), "YYYY-MM"), // 抽選年月
              tgtThisSttYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 3), "YYYY-MM"), // エントリー対象開始月
              tgtThisEndYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 5), "YYYY-MM"), // エントリー対象開始月
              alyNextYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 3), "YYYY-MM"), // エントリー年月
              ltyNextYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 4), "YYYY-MM"), // 抽選年月
              tgtNextSttYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 6), "YYYY-MM"), // エントリー対象開始月
              tgtNextEndYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 8), "YYYY-MM"), // エントリー対象開始月
              rsvThisOpenYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 1), "YYYY-MM"),
              rsvThisEndYearMthBfrOpen: _hmDTM.f(_hmDTM.addMth(_baseFdm, 2),"YYYY-MM"),
              rsvThisEndYearMthAtrOpen: _hmDTM.f(_hmDTM.addMth(_baseFdm, 5),"YYYY-MM"),
            }
          : // _baseDrc == 2
            {
              alyThisYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 0), "YYYY-MM"), // エントリー年月
              ltyThisYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 1), "YYYY-MM"), // 抽選年月
              tgtThisSttYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 3), "YYYY-MM"), // エントリー対象開始月
              tgtThisEndYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 5), "YYYY-MM"), // エントリー対象開始月
              alyNextYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 3), "YYYY-MM"), // エントリー年月
              ltyNextYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 4), "YYYY-MM"), // 抽選年月
              tgtNextSttYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 6), "YYYY-MM"), // エントリー対象開始月
              tgtNextEndYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 8), "YYYY-MM"), // エントリー対象開始月
              rsvThisOpenYearMth: _hmDTM.f(_hmDTM.addMth(_baseFdm, 1), "YYYY-MM"),
              rsvThisEndYearMthBfrOpen: _hmDTM.f(_hmDTM.addMth(_baseFdm, 5),"YYYY-MM"),
              rsvThisEndYearMthAtrOpen: _hmDTM.f(_hmDTM.addMth(_baseFdm, 5),"YYYY-MM"),
            };
      _dz.rsvSttDate = _hmDTM.addDay(_dz.tdy, _hm.n(_rz.S06010312)); // 予約受付終了日数
      _dz.rsvOpenDtm =
        _hmDTM.addDay(
          _tgtz.rsvThisOpenYearMth + "-01",
          _hm.n(_rz.S06010112) - 1
        ) +
        " " +
        _rz.S06010122 +
        ":00"; // 予約解禁日

      const _alyThisSttDate = _hmDTM.addDay(_tgtz.alyThisYearMth + "-01",Number(_rz.S07010112) - 1); // エントリー受付開始日
      //hf.l(`icm 2324: ${_tgtz.alyThisYearMth}, ${_rz.S07010112}, ${_alyThisSttDate}`);
      const _alyThisEndDate =
        _rz.S07010122 == 31 // 月末への対応
          ? _hmDTM.cvtLdm(_tgtz.alyThisYearMth + "-01")
          : _hmDTM.addDay(
              _tgtz.alyThisYearMth + "-01",
              Number(_rz.S07010122) - 1
            ); // エントリー受付終了日
      const _tgtThisSttYearMth = _tgtz.tgtThisSttYearMth; // エントリー対象開始月
      const _tgtThisEndYearMth = _tgtz.tgtThisEndYearMth; // エントリー対象終了月
      const _tgtThisSttDate = _tgtThisSttYearMth + "-01"; // エントリー対象開始日
      const _tgtThisEndDate = _hmDTM.cvtLdm(_tgtThisEndYearMth + "-01"); // エントリー対象終了日
      const _tgtThisSttMth = _hmDTM.cvtMth(_tgtThisSttYearMth + "-01");
      const _tgtThisEndMth = _hmDTM.cvtMth(_tgtThisEndYearMth + "-01");
      const _rsvThisEndDateBfrOpen = _hmDTM.cvtLdm(
        _tgtz.rsvThisEndYearMthBfrOpen + "-01"
      );
      const _rsvThisEndDateAtrOpen = _hmDTM.cvtLdm(
        _tgtz.rsvThisEndYearMthAtrOpen + "-01"
      );

      const _alyNextSttDate = _hmDTM.addDay(
        _tgtz.alyNextYearMth + "-01",
        Number(_rz.S07010112) - 1
      ); // エントリー受付開始日
      const _alyNextEndDate =
        _rz.S07010122 == 31 // 月末への対応
          ? _hmDTM.cvtLdm(_tgtz.alyNextYearMth + "-01")
          : _hmDTM.addDay(
              _tgtz.alyNextYearMth + "-01",
              Number(_rz.S07010122) - 1
            ); // エントリー受付終了日
      const _tgtNextSttYearMth = _tgtz.tgtNextSttYearMth; // エントリー対象開始月
      const _tgtNextEndYearMth = _tgtz.tgtNextEndYearMth; // エントリー対象終了月
      const _tgtNextSttDate = _tgtNextSttYearMth + "-01"; // エントリー対象開始日
      const _tgtNextEndDate = _hmDTM.cvtLdm(_tgtNextEndYearMth + "-01"); // エントリー対象終了日
      const _tgtNextSttMth = _hmDTM.cvtMth(_tgtNextSttYearMth + "-01");
      const _tgtNextEndMth = _hmDTM.cvtMth(_tgtNextEndYearMth + "-01");

      // エントリー抽選結果公開日時・メッセージ
      _dz.alyOpenDtm = _hmDTM.addDay(_hmDTM.cvtFdm(_tgtz.ltyThisYearMth), Number(_rz.S08010112) - 1) + ` ${_rz.S08010122}:00`;
      _dz.rsvOpenMsg = `${_hmDTM.f(
        _tgtThisSttDate,
        "年月",
        false
      )}〜${_tgtThisEndMth}月のご予約は【${_hmDTM.f(_alyThisSttDate,"年月日",false)}〜${_hmDTM.f(_alyThisEndDate,"年月日",false)}】の間に、抽選エントリーを受け付けております。\n抽選結果は、【${_dz.alyOpenDtm}】以降に公開しております。`;
      //_dz.alyOpenMsg = `現在は、受付期間外です。次回エントリーは、【${_hmDTM.f(_alyThisSttDate, "年月日",false)}〜${_hmDTM.f(_alyThisEndDate, "年月日",false)}】の間に、受け付けております。`;
      _dz.alyOpenMsg = `現在は、受付期間外です。次回エントリーは、【${_hmDTM.f(_alyNextSttDate, "年月日",false)}〜${_hmDTM.f(_alyNextEndDate, "年月日",false)}】の間に、受け付けております。`;
      //hf.l(`icm 2359: ${_dz.alyOpenMsg}`);

      _dz.bAlyPrd = false; // apply period
      if (_dz.tdy < _alyThisSttDate) {
        // エントリー期間前
        _dz.alyMsg0 = `次回エントリー`;
        _dz.alyMsg1 = `${_hmDTM.f(
          _tgtThisSttDate,
          "年月",
          false
        )}〜${_tgtThisEndMth}月 利用予約\n${_hmDTM.f(
          _alyThisSttDate,
          "月日",
          false
        )} からエントリー受付予定`;
        _dz.alyMsg2 = `最大数 ： ${_hmDTM.f(
          _tgtThisSttDate,
          "年月",
          false
        )}〜${_tgtThisEndMth}月 ${_rz.S07010212}件`;
        _dz.tgtSttDate = _tgtThisSttDate;
        _dz.tgtEndDate = _tgtThisEndDate;
        _dz.alySttDate = _alyThisSttDate;
        _dz.alyEndDate = _alyThisEndDate;
      } else if (_dz.tdy >= _alyThisSttDate && _dz.tdy <= _alyThisEndDate) {
        // エントリー期間
        _dz.alyMsg0 = `受付中のエントリー`;
        _dz.alyMsg1 = `${_hmDTM.f(
          _tgtThisSttDate,
          "年月",
          false
        )}〜${_tgtThisEndMth}月 利用予約\nエントリー受付中`;
        _dz.alyMsg2 = `最大数 ： ${_hmDTM.f(
          _tgtThisSttDate,
          "年月",
          false
        )}〜${_tgtThisEndMth}月  ${_rz.S07010212}件`;
        _dz.tgtSttDate = _tgtThisSttDate;
        _dz.tgtEndDate = _tgtThisEndDate;
        _dz.alySttDate = _alyThisSttDate;
        _dz.alyEndDate = _alyThisEndDate;
        _dz.bAlyPrd = true;
      } else if (_dz.tdy > _alyThisEndDate && _dz.now < _dz.alyOpenDtm) {
        // エントリー期間後・抽選公開前
        _dz.alyMsg0 = `次回エントリー`;
        _dz.alyMsg1 = `受付終了\n${_hmDTM.f(_tgtThisSttDate,"年月",false)}〜${_tgtThisEndMth}月 利用抽選結果\n${_hmDTM.f(_dz.alyOpenDtm,"月日時分",false)}発表予定`;
        _dz.alyMsg2 = `最大数 ： ${_hmDTM.f(_tgtThisSttDate,"年月",false)}〜${_tgtThisEndMth}月 ${_rz.S07010212}件`;
        _dz.tgtSttDate = _tgtNextSttDate;
        _dz.tgtEndDate = _tgtNextEndDate;
        _dz.alySttDate = _alyNextSttDate;
        _dz.alyEndDate = _alyNextEndDate;
      } else {
        // エントリー期間後・抽選公開後
        _dz.alyMsg0 = `次回エントリー`;
        _dz.alyMsg1 = `${_hmDTM.f(
          _tgtThisSttDate,
          "年月",
          false
        )}〜${_tgtThisEndMth}月 利用予約\n抽選結果発表`;
        _dz.alyMsg2 = `最大数 ： ${_hmDTM.f(
          _tgtThisSttDate,
          "年月",
          false
        )}〜${_tgtThisEndMth}月 ${_rz.S07010212}件`;
        _dz.tgtSttDate = _tgtNextSttDate;
        _dz.tgtEndDate = _tgtNextEndDate;
        _dz.alySttDate = _alyNextSttDate;
        _dz.alyEndDate = _alyNextEndDate;
      }

      _dz.alyMthSttDate = _dz.tgtSttDate;
      _dz.alyMthEndDate = _dz.tgtEndDate;

//_hm.l(`icm 1928c: here`);
      if (pz?.i15r_fst || pz?.i18r_fst) {
//_hm.l(`icm 1928d: here`);
        const _i15z = await icvI15___Mz.loadI15rDzAsync({
          i15r_fst: pz?.i15r_fst,
          i18r_fst: pz?.i18r_fst,
        });
        const _i15rz = _i15z.i15rz;
//_hm.l(`icm 1928e: here`);
        if (_hm.f(_i15rz)) {
//_hm.l(`icm 1928f: here`);
          _dz.rsvEndDate =
            _i15rz.i15ra3100i == 120 // 2週間後
              ? _hmDTM.addDay(_dz.tdy, 14)
              : _i15rz.i15ra3100i == 130 // 3週間後
              ? _hmDTM.addDay(_dz.tdy, 21)
              : _i15rz.i15ra3100i == 200 // 当月末
              ? _date0Lst
              : _i15rz.i15ra3100i == 210 // 1ヶ月後月末
              ? _date1Lst
              : _i15rz.i15ra3100i == 210 // 2ヶ月後月末
              ? _date2Lst
              : _i15rz.i15ra3100i == 300 && _dz.now < _dz.rsvOpenDtm // 解禁前
              ? _rsvThisEndDateBfrOpen
              : _i15rz.i15ra3100i == 300 && _dz.now >= _dz.rsvOpenDtm // 解禁後
              ? _rsvThisEndDateAtrOpen
              : null;

          _dz.rsvMsg1 = `${_hmDTM.f(
            _dz.rsvSttDate,
            "月日",
            false
          )} から ${_hmDTM.f(
            _dz.rsvEndDate,
            "月日",
            false
          )}\nまでの予約を受付中`;

          _dz.rsvMthCnt = _hmDTM.getDrcMth(_dz.rsvSttDate, _dz.rsvEndDate) + 1
//          _hm.l(`icm 2156: ${_dz.rsvMthCnt}`)
/*
          const _day = _hm.n(_dz.tdy.substr(-2, 2));
          const _maxCnt0 =
            _day >= _i15rz.i15ra8010i ? _i15rz.i15ra8020i : _i15rz.i15ra8120i; // 当月最大件数
          const _maxCnt1 =
            _day >= _i15rz.i15ra8110i ? _i15rz.i15ra8120i : _i15rz.i15ra8220i; // 1カ月前最大件数
          const _maxCnt2 =
            _day >= _i15rz.i15ra8210i ? _i15rz.i15ra8220i : _i15rz.i15ra8320i; // 2カ月前最大件数
          const _maxCnt3 =
            _day >= _i15rz.i15ra8310i ? _i15rz.i15ra8320i : _i15rz.i15ra8420i; // 3カ月前最大件数
          const _maxCnt4 =
            _day >= _i15rz.i15ra8410i ? _i15rz.i15ra8420i : _i15rz.i15ra8520i; // 4カ月前最大件数
          const _maxCnt5 = _day >= _i15rz.i15ra8510i ? _i15rz.i15ra8520i : 0; // 5カ月前最大件数
*/
          const _now = _dz.now.substr(8, 8);
          const _maxCnt0 =
            _now >= _hm.pdg(_i15rz.i15ra8010i, 2) + ' ' + _i15rz.i15ra8012s  ? _i15rz.i15ra8020i : _i15rz.i15ra8120i; // 当月最大件数
          const _maxCnt1 =
            _now >= _hm.pdg(_i15rz.i15ra8110i, 2) + ' ' + _i15rz.i15ra8112s ? _i15rz.i15ra8120i : _i15rz.i15ra8220i; // 1カ月前最大件数
          const _maxCnt2 =
            _now >= _hm.pdg(_i15rz.i15ra8210i, 2) + ' ' + _i15rz.i15ra8212s ? _i15rz.i15ra8220i : _i15rz.i15ra8320i; // 2カ月前最大件数
          const _maxCnt3 =
            _now >= _hm.pdg(_i15rz.i15ra8310i, 2) + ' ' + _i15rz.i15ra8312s ? _i15rz.i15ra8320i : _i15rz.i15ra8420i; // 3カ月前最大件数
          const _maxCnt4 =
            _now >= _hm.pdg(_i15rz.i15ra8410i, 2) + ' ' + _i15rz.i15ra8412s ? _i15rz.i15ra8420i : _i15rz.i15ra8520i; // 4カ月前最大件数
          const _maxCnt5 = 
            _now >= _hm.pdg(_i15rz.i15ra8510i, 2) + ' ' + _i15rz.i15ra8512s ? _i15rz.i15ra8520i : 0; // 5カ月前最大件数
          _dz.rsvMsg2 = `最大数 ： ${_mth0}月${_maxCnt0}件、${_mth1}月${_maxCnt1}件、${_mth2}月${_maxCnt2}件、${_mth3}月${_maxCnt3}件、${_mth4}月${_maxCnt4}件、${_mth5}月${_maxCnt5}件`;

          _dz.rsvMaxCntz = {
            [_yearMth0]: _maxCnt0, // 当月予約可能件数
            [_yearMth1]: _maxCnt1, // 1カ月前予約可能件数
            [_yearMth2]: _maxCnt2, // 2カ月前予約可能件数
            [_yearMth3]: _maxCnt3, // 3カ月前予約可能件数
            [_yearMth4]: _maxCnt4, // 4カ月前予約可能件数
            [_yearMth5]: _maxCnt5, // 5カ月前予約可能件数
          };

          _dz.bAlyAbl = _i15rz.i15ra2100i == 1 ? true : false; // エントリー可能
        }
      }
    } else {
      // エントリー期間：１カ月の場合

      _dz.rsvSttDate = _hmDTM.addDay(_dz.tdy, _hm.n(_rz.S06010312)); // 予約受付終了日数
      _dz.rsvOpenDtm =
        _hmDTM.addDay(_hmDTM.cvtFdm(_dz.tdy), _hm.n(_rz.S06010112) - 1) +
        " " +
        _rz.S06010122 +
        ":00"; // 予約解禁日

      const _alyThisMth = _mth2; // 今回
      const _alyThisYearMth = _yearMth2; // 今回
      const _alyThisSttDate = _hmDTM.addDay(
        _hmDTM.cvtFdm(_dz.tdy),
        _hm.n(_rz.S07010112) - 1
      ); // 予約受付開始日
      const _alyThisEndDate = _hmDTM.addDay(
        _hmDTM.cvtFdm(_dz.tdy),
        _hm.n(_rz.S07010122) - 1
      ); // 予約受付終了日
      const _alyNextMth = _mth3; // 次回
      const _alyNextYearMth = _yearMth3; // 次回
      const _alyNextSttDate = _hmDTM.addDay(
        _hmDTM.cvtFdm(_hmDTM.addMth(_dz.tdy, 1)),
        _hm.n(_rz.S07010112) - 1
      ); // 予約受付開始日
      const _alyNextEndDate = _hmDTM.addDay(
        _hmDTM.cvtFdm(_hmDTM.addMth(_dz.tdy, 1)),
        _hm.n(_rz.S07010122) - 1
      ); // 予約受付終了日

      // エントリー抽選結果公開日時・メッセージ
      _dz.alyOpenDtm =
        _hmDTM.addDay(_hmDTM.cvtFdm(_hmDTM.getTdy()), Number(_rz.S08010112) - 1) +
        ` ${_rz.S08010122}:00`;
      _dz.rsvOpenMsg = `翌々月のご予約は【${_rz.S07010112}日〜${_rz.S07010122}日】の間に、抽選エントリーを受け付けております。\n抽選結果は、【${_rz.S08010112}日${_rz.S08010122}】以降に公開しております。`;
      _dz.alyOpenMsg = `現在は、受付期間外です。エントリーは、毎月【${_rz.S07010112}日〜${_rz.S07010122}日】の間に、抽選エントリーを受け付けております。`;

      _dz.bAlyPrd = false; // apply period
      if (_dz.tdy < _alyThisSttDate) {
        // エントリー期間前
        _dz.alyMsg0 = `次回エントリー`;
        _dz.alyMsg1 = `${_hmDTM.f(
          _alyThisYearMth + "-01",
          "月",
          false
        )}利用予約\n${_hmDTM.f(
          _alyThisSttDate,
          "月日",
          false
        )} からエントリー受付予定`;
        _dz.alyMsg2 = `最大数 ： ${_alyThisMth}月${_rz.S07010212}件`;
        _dz.alyMth = _alyThisYearMth;
        _dz.alySttDate = _alyThisSttDate;
        _dz.alyEndDate = _alyThisEndDate;
      } else if (_dz.tdy >= _alyThisSttDate && _dz.tdy <= _alyThisEndDate) {
        // エントリー期間
        _dz.alyMsg0 = `受付中のエントリー`;
        _dz.alyMsg1 = `${_hmDTM.f(
          _alyThisYearMth + "-01",
          "月",
          false
        )}利用予約\nエントリー受付中`;
        _dz.alyMsg2 = `最大数 ： ${_alyThisMth}月${_rz.S07010212}件`;
        _dz.alyMth = _alyThisYearMth;
        _dz.alySttDate = _alyThisSttDate;
        _dz.alyEndDate = _alyThisEndDate;
        _dz.bAlyPrd = true;
      } else if (_dz.tdy > _alyThisEndDate && _dz.now < _dz.alyOpenDtm) {
        // エントリー期間後・抽選公開前
        _dz.alyMsg0 = `次回エントリー`;
        _dz.alyMsg1 = `受付終了\n${_hmDTM.f(_alyThisYearMth + "-01","月",false)}月利用抽選結果\n${_hmDTM.f(_dz.alyOpenDtm, "月日時分", false)}発表予定`;
        _dz.alyMsg2 = `最大数 ： ${_alyNextMth}月${_rz.S07010212}件`;
        //        _dz.alyMth = _alyNextYearMth;
        _dz.alyMth = _alyThisYearMth; // 抽選公開前までは当月の扱い
        _dz.alySttDate = _alyNextSttDate;
        _dz.alyEndDate = _alyNextEndDate;
      } else {
        // エントリー期間後・抽選公開後
        _dz.alyMsg0 = `次回エントリー`;
        _dz.alyMsg1 = `${_alyThisYearMth}月利用予約\n抽選結果発表`;
        _dz.alyMsg2 = `最大数 ： ${_alyNextMth}月${_rz.S07010212}件`;
        _dz.alyMth = _alyNextYearMth;
        _dz.alySttDate = _alyNextSttDate;
        _dz.alyEndDate = _alyNextEndDate;
      }
      _dz.alyMthSttDate = `${_dz.alyMth}-01`;
      _dz.alyMthEndDate = _hmDTM.cvtLdm(_dz.alyMthSttDate);

      if (pz?.i15r_fst || pz?.i18r_fst) {
        const _i15z = await icvI15___Mz.loadI15rDzAsync({
          i15r_fst: pz?.i15r_fst,
          i18r_fst: pz?.i18r_fst,
        });
        const _i15rz = _i15z.i15rz;
        if (_hm.f(_i15rz)) {
          _dz.rsvEndDate =
            _i15rz.i15ra3100i == 120 // 2週間後
              ? _hmDTM.addDay(_dz.tdy, 14)
              : _i15rz.i15ra3100i == 130 // 3週間後
              ? _hmDTM.addDay(_dz.tdy, 21)
              : _i15rz.i15ra3100i == 200 // 当月末
              ? _date0Lst
              : _i15rz.i15ra3100i == 210 // 一ヶ月後月末
              ? _date1Lst
              : _i15rz.i15ra3100i == 210 // 二ヶ月後月末
              ? _date2Lst
              : _i15rz.i15ra3100i == 300 && _dz.now < _dz.rsvOpenDtm // 解禁前
              ? _date1Lst
              : _i15rz.i15ra3100i == 300 && _dz.now >= _dz.rsvOpenDtm // 解禁後
              ? _date2Lst
              : null;
          _dz.rsvMsg1 = `${_hmDTM.f(
            _dz.rsvSttDate,
            "月日",
            false
          )} から ${_hmDTM.f(
            _dz.rsvEndDate,
            "月日",
            false
          )}\nまでの予約を受付中`;
/*
          const _day = _hm.n(_dz.tdy.substr(-2, 2));
          const _maxCnt0 =
            _day >= _i15rz.i15ra8010i ? _i15rz.i15ra8020i : _i15rz.i15ra8120i; // 当月最大件数
          const _maxCnt1 =
            _day >= _i15rz.i15ra8110i ? _i15rz.i15ra8120i : _i15rz.i15ra8220i; // 1カ月前最大件数
          const _maxCnt2 = _day >= _i15rz.i15ra8210i ? _i15rz.i15ra8220i : 0; // 2カ月前最大件数
          const _maxCnt3 = 0; // 3カ月前最大件数
          const _maxCnt4 = 0; // 4カ月前最大件数
          const _maxCnt5 = 0; // 5カ月前最大件数
*/
          const _now = _dz.now.substr(8, 8);
          const _maxCnt0 =
            _now >= _hm.pdg(_i15rz.i15ra8010i, 2) + ' ' + _i15rz.i15ra8012s ? _i15rz.i15ra8020i : _i15rz.i15ra8120i; // 当月最大件数
          const _maxCnt1 =
            _now >= _hm.pdg(_i15rz.i15ra8110i, 2) + ' ' + _i15rz.i15ra8112s ? _i15rz.i15ra8120i : _i15rz.i15ra8220i; // 1カ月前最大件数
          const _maxCnt2 = 
            _now >= _hm.pdg(_i15rz.i15ra8210i, 2) + ' ' + _i15rz.i15ra8212s ? _i15rz.i15ra8220i : 0; // 2カ月前最大件数
          const _maxCnt3 = 0; // 3カ月前最大件数
          const _maxCnt4 = 0; // 4カ月前最大件数
          const _maxCnt5 = 0; // 5カ月前最大件数
          _dz.rsvMsg2 = `最大数 ： ${_mth0}月${_maxCnt0}件、${_mth1}月${_maxCnt1}件、${_mth2}月${_maxCnt2}件`;

          _dz.rsvMaxCntz = {
            [_yearMth0]: _maxCnt0, // 当月予約可能件数
            [_yearMth1]: _maxCnt1, // 1カ月前予約可能件数
            [_yearMth2]: _maxCnt2, // 2カ月前予約可能件数
            [_yearMth3]: _maxCnt3, // 3カ月前予約可能件数
            [_yearMth4]: _maxCnt4, // 4カ月前予約可能件数
            [_yearMth5]: _maxCnt5, // 5カ月前予約可能件数
          };

          _dz.bAlyAbl = _i15rz.i15ra2100i == 1 ? true : false; // エントリー可能
        }
      }
    }
  }

  //hf.l(`icm 2656a: ${hf.s(_dz)}`);
  //hf.l(`icm 2656b: ${_gUserz.crt._31rz?._fst}, ${_dz.S01999232}`);
  _gStgz.rlc(_dz);
};

export const sltI1zz = (pz: {
  // split i1zz,
  i1zz: _ht.dz;
  i17rs: _ht.ls;
}) => {
  const _gUserz = gs.useUserz();
  const _i1zs = [] as _ht.ls;
  const _dz = _hm.cvtLsToDzLs(
    ihd.nd(pz.i1zz.i1z1s),
    (_i1z1z: _ht.dz) => _i1z1z.i1z1d1100s
  );
  Object.keys(_dz).map((_date: _ht.s) => {
    const _i1zrz = _hm.copyDz(pz.i1zz.i1zrz);
    const _i1z3z = _hm.copyDz(pz.i1zz.i1z3z);
    const _i1z4z = _hm.copyDz(pz.i1zz.i1z4z);
    const _i18rz = _hm.copyDz(pz.i1zz.i18rz);
    _hm.udtDz(_i1zrz, {
      i1zr_31r1f: _gUserz.crt._31rz._fst,
      i1zrd1100s: _hmDTM.getTdy(),
      i1zrd2100s: _hmDTM.getTdy(),
      i1zrd3100s: _date,
//      i1zrs1100i: 80, 本予約として登録
      i1zrs1200i: 10,
      i1zra6100i: 1, // 経路
    });
    const _i1z1s = _dz[_date];
    const _i1z2s = pz.i1zz.i1z2s;
    const _i1zz = {
      i1zrz: _i1zrz,
      i1z1s: _i1z1s,
      i1z2s: _i1z2s,
      i1z3z: _i1z3z,
      i1z4z: _i1z4z,
      i18rz: _i18rz,
    };
    icm.udtI1z3z({
      i1zz: _i1zz,
      i17rs: pz.i17rs,
    });
    icm.setI1z3d1100s({
      i1zz: _i1zz,
    });
    _i1zs.push(_i1zz);
  });
  return _i1zs;
};

export const udtI1zrs1100i = (pz: {
  // 予約状況の更新
  i1zz: _ht.dz;
  i1zrs1100i: _ht.n;
}) => {
  if (
    pz.i1zrs1100i == 90 &&
    pz.i1zz?.i1zrz.i1zrs1100i != 90 &&
    !_hm.f(pz.i1zz?.i1z3z.i1z3d2100s)
  ) { // 本予約の
    pz.i1zz.i1z3z.i1z3d2100s = _hmDTM.getTdy();
    pz.i1zz.i1z3z.i1z3s1100i = 40;
    pz.i1zz.i1z3z.i1z3t3100i = 10;
  }
  if (pz.i1zrs1100i == 80) { // 仮予約の場合
    pz.i1zz.i1z3z.i1z3d2100s = "";
    pz.i1zz.i1z3z.i1z3s1100i = 20;
    pz.i1zz.i1z3z.i1z3t3100i = -1;
  }
  pz.i1zz.i1zrz.i1zrs1100i = pz.i1zrs1100i;
};

export const udtI1zzFromI18rz = (pz: { i1zz: _ht.dz; i18rz: _ht.dz }) => {
  pz.i1zz.i1z3z.i1z3t1100i = pz.i18rz.i18raa100i; // 減免率区分
  pz.i1zz.i1z3z.i1z3m2100i =
    (_hm.n(pz.i1zz.i1z3z.i1z3m1110i) * _hm.n(pz.i18rz.i18raa200i)) / 100; // 減免率
  pz.i1zz.i1z3z.i1z3t2100i = pz.i18rz.i18raa300i; // 減免理由
  pz.i1zz.i1zrz.i1zra2100s = pz.i18rz.i18ra2110s; // 代表者名
  pz.i1zz.i1zrz.i1zra3100s = pz.i18rz.i18ra3510s; // 電話番号（主）
  pz.i1zz.i1zrz.i1zra4100s = pz.i18rz.i18ra6100s; // 活動内容
  pz.i1zz.i18rz = pz.i18rz; // 団体
};
